// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Videos_videoContainer__U68Og {
  position: relative;
  height: 100vh;
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  background: #f8f9fa;
}

.Videos_videoLoadingMessage__LoMbE {
  text-align: center;
  padding: 60px;
  color: #1a5f3f;
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 16px;
  margin: 20px 0;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.1);
}

.Videos_videoEmptyState__bL4ry {
  text-align: center;
  padding: 60px;
  color: #64748b;
  font-size: 16px;
  background: linear-gradient(135deg, #f1f5f9 0%, #f8fafc 100%);
  border-radius: 16px;
  margin: 20px 0;
  border: 2px dashed #cbd5e1;
}

.Videos_videoGridLayout__vUjKX {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}

@media (max-width: 1024px) {
  .Videos_videoGridLayout__vUjKX {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .Videos_videoContainer__U68Og {
    padding: 15px;
  }

  .Videos_videoGridLayout__vUjKX {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .Videos_videoYearControls__VlV8T {
    flex-wrap: wrap;
    gap: 10px;
    width: 100% !important;
  }

  .Videos_videoYearButton__Ofkfs {
    width: 46px !important;
  }

  .Videos_videoYearSelector__kAaJc {
    order: -1;
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .Videos_videoGridLayout__vUjKX {
    grid-template-columns: 1fr;
  }

   .Videos_videoYearButton__Ofkfs {
    width: 35PX !important;
  }

}

.Videos_videoTile__gT7\\+q {
  display: block;
  text-decoration: none;
  color: inherit;
  position: relative;
}

.Videos_videoTileInner__7zzOI {
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  cursor: pointer;
  height: 250px;
}

.Videos_videoTileInner__7zzOI::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.Videos_videoTile__gT7\\+q:hover .Videos_videoTileInner__7zzOI {
  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);
  transform: translateY(-4px);
}

.Videos_videoTile__gT7\\+q:hover .Videos_videoTileInner__7zzOI::before {
  transform: scaleX(1);
}

.Videos_videoThumbnailWrapper__c5VV1 {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.Videos_videoThumbnail__F4KLM {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.Videos_videoTile__gT7\\+q:hover .Videos_videoThumbnail__F4KLM {
  transform: scale(1.05);
}

.Videos_videoPlayOverlay__u0UJl {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 95, 63, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.Videos_videoTile__gT7\\+q:hover .Videos_videoPlayOverlay__u0UJl {
  opacity: 1;
}

.Videos_videoPlayIcon__HwQ3Q {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.Videos_videoTile__gT7\\+q:hover .Videos_videoPlayIcon__HwQ3Q {
  transform: scale(1.1);
  background: #ffffff;
}

.Videos_videoContent__\\+Hjey {
  padding: 16px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.Videos_videoCaption__z9\\+bG {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.Videos_videoYearControls__VlV8T {
  position: relative;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 40px;
  padding: 15px;
  margin-top: 50px;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);
}

.Videos_videoNavBtn__2ZpxJ {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s ease;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 75px;
  backdrop-filter: blur(10px);
}

.Videos_videoNavBtn__2ZpxJ .Videos_videoArrowIcon__TRaKm {
  font-size: 20px;
  font-weight: bold;
}

.Videos_videoNavBtn__2ZpxJ:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);
}

.Videos_videoNavBtn__2ZpxJ:disabled {
  background: rgba(255, 255, 255, 0.1);
  cursor: not-allowed;
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.2);
  transform: none;
  box-shadow: none;
}

.Videos_videoYearSelector__kAaJc {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.15);
  padding: 6px;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.Videos_videoYearButton__Ofkfs {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 8px 14px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  width: 55px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.Videos_videoYearButton__Ofkfs:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
}

.Videos_videoActiveYear__I1y41 {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #1a5f3f !important;
  border-color: rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3) !important;
  font-weight: 700 !important;
}

.Videos_videoYearEllipsis__lmwqN {
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  font-weight: bold;
  padding: 0 10px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Videos_videoLoadMoreArea__bq2Tj {
  text-align: center;
  margin-top: 40px;
  padding: 30px;
}

.Videos_videoLoadMoreButton__w-cm0 {
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  color: white;
  border: none;
  border-radius: 14px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.3);
  margin-bottom: 16px;
}

.Videos_videoLoadMoreButton__w-cm0:hover {
  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.4);
}

.Videos_videoItemCounter__qqJ-U {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  background: rgba(26, 95, 63, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Main pages/Videos.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;IACf,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;GAEC;IACC,sBAAsB;EACxB;;AAEF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,iDAAiD;EACjD,0DAA0D;EAC1D,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".videoContainer {\r\n  position: relative;\r\n  height: 100vh;\r\n  width: 80%;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  direction: rtl;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.videoLoadingMessage {\r\n  text-align: center;\r\n  padding: 60px;\r\n  color: #1a5f3f;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\r\n  border-radius: 16px;\r\n  margin: 20px 0;\r\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.1);\r\n}\r\n\r\n.videoEmptyState {\r\n  text-align: center;\r\n  padding: 60px;\r\n  color: #64748b;\r\n  font-size: 16px;\r\n  background: linear-gradient(135deg, #f1f5f9 0%, #f8fafc 100%);\r\n  border-radius: 16px;\r\n  margin: 20px 0;\r\n  border: 2px dashed #cbd5e1;\r\n}\r\n\r\n.videoGridLayout {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 24px;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .videoGridLayout {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .videoContainer {\r\n    padding: 15px;\r\n  }\r\n\r\n  .videoGridLayout {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 16px;\r\n  }\r\n\r\n  .videoYearControls {\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    width: 100% !important;\r\n  }\r\n\r\n  .videoYearButton {\r\n    width: 46px !important;\r\n  }\r\n\r\n  .videoYearSelector {\r\n    order: -1;\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .videoGridLayout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n   .videoYearButton {\r\n    width: 35PX !important;\r\n  }\r\n\r\n}\r\n\r\n.videoTile {\r\n  display: block;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  position: relative;\r\n}\r\n\r\n.videoTileInner {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\r\n  border-radius: 16px;\r\n  transition: all 0.3s ease;\r\n  border: 1px solid #e2e8f0;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n  position: relative;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n  height: 250px;\r\n}\r\n\r\n.videoTileInner::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);\r\n  transform: scaleX(0);\r\n  transform-origin: center;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.videoTile:hover .videoTileInner {\r\n  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);\r\n  transform: translateY(-4px);\r\n}\r\n\r\n.videoTile:hover .videoTileInner::before {\r\n  transform: scaleX(1);\r\n}\r\n\r\n.videoThumbnailWrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 180px;\r\n  overflow: hidden;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\r\n}\r\n\r\n.videoThumbnail {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.videoTile:hover .videoThumbnail {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.videoPlayOverlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(26, 95, 63, 0.8);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  opacity: 0;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.videoTile:hover .videoPlayOverlay {\r\n  opacity: 1;\r\n}\r\n\r\n.videoPlayIcon {\r\n  width: 60px;\r\n  height: 60px;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.videoTile:hover .videoPlayIcon {\r\n  transform: scale(1.1);\r\n  background: #ffffff;\r\n}\r\n\r\n.videoContent {\r\n  padding: 16px;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.videoCaption {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #1a202c;\r\n  line-height: 1.3;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.videoYearControls {\r\n  position: relative;\r\n  bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin-bottom: 40px;\r\n  padding: 15px;\r\n  margin-top: 50px;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);\r\n}\r\n\r\n.videoNavBtn {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  border-radius: 20px;\r\n  padding: 10px 16px;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  height: 44px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  min-width: 75px;\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.videoNavBtn .videoArrowIcon {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n}\r\n\r\n.videoNavBtn:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-color: rgba(255, 255, 255, 0.5);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.videoNavBtn:disabled {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  cursor: not-allowed;\r\n  color: rgba(255, 255, 255, 0.5);\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.videoYearSelector {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: rgba(255, 255, 255, 0.15);\r\n  padding: 6px;\r\n  border-radius: 16px;\r\n  backdrop-filter: blur(10px);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.videoYearButton {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: white;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 12px;\r\n  padding: 8px 14px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  width: 55px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.videoYearButton:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-color: rgba(255, 255, 255, 0.4);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.videoActiveYear {\r\n  background: rgba(255, 255, 255, 0.9) !important;\r\n  color: #1a5f3f !important;\r\n  border-color: rgba(255, 255, 255, 0.9) !important;\r\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3) !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.videoYearEllipsis {\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  padding: 0 10px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.videoLoadMoreArea {\r\n  text-align: center;\r\n  margin-top: 40px;\r\n  padding: 30px;\r\n}\r\n\r\n.videoLoadMoreButton {\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 14px;\r\n  padding: 16px 32px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.3);\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.videoLoadMoreButton:hover {\r\n  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.4);\r\n}\r\n\r\n.videoItemCounter {\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  display: inline-block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoContainer": `Videos_videoContainer__U68Og`,
	"videoLoadingMessage": `Videos_videoLoadingMessage__LoMbE`,
	"videoEmptyState": `Videos_videoEmptyState__bL4ry`,
	"videoGridLayout": `Videos_videoGridLayout__vUjKX`,
	"videoYearControls": `Videos_videoYearControls__VlV8T`,
	"videoYearButton": `Videos_videoYearButton__Ofkfs`,
	"videoYearSelector": `Videos_videoYearSelector__kAaJc`,
	"videoTile": `Videos_videoTile__gT7+q`,
	"videoTileInner": `Videos_videoTileInner__7zzOI`,
	"videoThumbnailWrapper": `Videos_videoThumbnailWrapper__c5VV1`,
	"videoThumbnail": `Videos_videoThumbnail__F4KLM`,
	"videoPlayOverlay": `Videos_videoPlayOverlay__u0UJl`,
	"videoPlayIcon": `Videos_videoPlayIcon__HwQ3Q`,
	"videoContent": `Videos_videoContent__+Hjey`,
	"videoCaption": `Videos_videoCaption__z9+bG`,
	"videoNavBtn": `Videos_videoNavBtn__2ZpxJ`,
	"videoArrowIcon": `Videos_videoArrowIcon__TRaKm`,
	"videoActiveYear": `Videos_videoActiveYear__I1y41`,
	"videoYearEllipsis": `Videos_videoYearEllipsis__lmwqN`,
	"videoLoadMoreArea": `Videos_videoLoadMoreArea__bq2Tj`,
	"videoLoadMoreButton": `Videos_videoLoadMoreButton__w-cm0`,
	"videoItemCounter": `Videos_videoItemCounter__qqJ-U`
};
export default ___CSS_LOADER_EXPORT___;
